/** Various relative paths to logos, as hosted on udemy-django */
export const UDEMY_RELATIVE_LOGO_URLS = {
  udemyLogoUrl: '/staticx/udemy/images/v7/logo-udemy.svg',
  udemyLogoInvertedUrl: '/staticx/udemy/images/v7/logo-udemy-inverted.svg',
  ubLogoUrl: '/staticx/udemy/images/v7/logo-ub.svg',
  ubLogoInvertedUrl: '/staticx/udemy/images/v7/logo-ub-inverted.svg',
  ugLogoUrl: '/staticx/udemy/images/v7/logo-ug.svg',
  ugLogoInvertedUrl: '/staticx/udemy/images/v7/logo-ug-inverted.svg',
  udemyProLogoUrl: '/staticx/udemy/images/v7/logo-upro.svg',
  udemyBenesseLogoUrl: '/staticx/udemy/images/v7/logo-udemy-benesse.svg',
  udemyBenesseLogoInvertedUrl: '/staticx/udemy/images/v7/logo-udemy-benesse-inverted.svg'
};
//# sourceMappingURL=logo-urls.js.map